import { useMemo } from 'react';
import { getStartingSize } from '../utils/styleHelpers.js';
import { useTheme } from './useTheme.js';
import { u as useWindowSizeStore } from '../providers/windowSizeContext/windowSizeContext.js';
import { getCurrentSizeClass } from '../utils/responsiveHelpers.js';

function useGetCurrentSizeClass(size, defaultSize, safeSizes) {
  var startingSize = getStartingSize(size, defaultSize, safeSizes);
  var _useWindowSizeStore = useWindowSizeStore(function (state) {
      return state.width;
    }),
    windowWidth = _useWindowSizeStore.state;
  var _useTheme = useTheme(),
    breakpointAsArray = _useTheme.base.breakpointAsArray;
  var currentSizeClass = useMemo(function () {
    return getCurrentSizeClass(size, startingSize, safeSizes, breakpointAsArray, windowWidth);
  }, [windowWidth, size, safeSizes, startingSize, breakpointAsArray]);
  return currentSizeClass;
}

export { useGetCurrentSizeClass };
//# sourceMappingURL=useGetCurrentSizeClass.js.map
